import { types } from 'mobx-state-tree';

const MenuStore = types
  .model('Menu', {
    visible: types.optional(types.boolean, false),
  })
  .actions(self => ({
    show() {
      self.visible = true;
    },

    hide() {
      self.visible = false;
    },
  }));

export default MenuStore;



// WEBPACK FOOTER //
// ./src/stores/MenuStore.js